/** Code tables and decoders for /history/teras (ESP32-C3 board). Pure, no Firebase. */

/** Probe-ON voltage above this is the BMS cutting the pack off. */
export const BMS_PROBE_MV = 14000;

/** `rr` = esp_reset_reason(); only the codes the firmware doc spells out. */
const RESET: Record<number, string> = {
  1: "power-on",
  3: "software/OTA",
  4: "panic/exception",
  5: "watchdog",
  6: "watchdog",
  7: "watchdog",
  9: "brownout",
};
export const resetName = (rr: number | undefined): string =>
  rr === undefined ? "?" : RESET[rr] ?? `kode ${rr}`;

/** `pm` bitmask -> pump numbers, 1-based (1=P1, 2=P2, 4=P3, 8=P4). */
export function pumpsOn(pm: number | undefined): number[] {
  const out: number[] = [];
  for (let i = 0; i < 4; i++) if ((pm ?? 0) & (1 << i)) out.push(i + 1);
  return out;
}
